const PERCENTAGE_PER_RADIAN = 15.91549430919
const RADIANS_PER_PERCENTAGE_UNIT = 0.062831853071796

export const getPercentageFromAngle = (theta) => {
    const angle = theta + Math.PI / 2
    let percentage = angle * PERCENTAGE_PER_RADIAN
    if (percentage < 0 && percentage > -25){
        percentage = 100 + percentage
    }
    return percentage
}

export const getAngleFromPercentage = (percentage) => {
    let theta = (percentage-0.25)* 100 * RADIANS_PER_PERCENTAGE_UNIT
    return theta
}